'use client'
import React, { useState, useEffect, useRef } from 'react'

interface SimulatedProgressBarProps {
  onComplete?: () => void // Callback opcional ao terminar
}

// eslint-disable-next-line react/display-name
const FakeProgress = React.forwardRef(({ onComplete }: SimulatedProgressBarProps, ref) => {
  const [progress, setProgress] = useState(0) // Estado do progresso
  const [isProcessing, setIsProcessing] = useState(false) // Controle do processamento
  const intervalRef = useRef<NodeJS.Timeout | null>(null) // Referência do intervalo

  // Expondo o método start para o pai via ref
  React.useImperativeHandle(ref, () => ({
    start: async (asyncTask: () => Promise<void>, duration = 45000) => {
      if (isProcessing) return // Evita chamadas repetidas enquanto está processando

      setIsProcessing(true)
      setProgress(0) // Reinicia o progresso

      try {
        // Marca o tempo de início
        const startTime = Date.now()
        const interval = setInterval(() => {
          const elapsedTime = Date.now() - startTime // Tempo decorrido desde o início
          const progress = Math.min((elapsedTime / duration) * 100, 97) // Progressão até 90%

          setProgress(progress) // Atualiza o progresso na tela

          if (progress >= 97) {
            clearInterval(interval) // Para o intervalo quando alcançar 90%
          }
        }, 350) // Atualiza a cada 150ms (ajustável)

        // Espera pela execução da tarefa assíncrona
        await asyncTask()
        setProgress(100) // Completa o progresso para 100% após o término da tarefa

        onComplete?.() // Chama o callback após a conclusão
      } catch (error) {
        console.warn('Erro ao executar o método assíncrono:', error)
      } finally {
        setIsProcessing(false)
      }
    }
  }))

  useEffect(
    () =>
      // Limpeza do intervalo ao desmontar o componente
      () => {
        if (intervalRef.current) clearInterval(intervalRef.current)
      },
    []
  )

  return (
    <div style={{ width: '100%', padding: '10px' }}>
      <div
        style={{
          width: `${progress}%`,
          height: '10px',
          backgroundColor: '#4caf50',
          transition: 'width 0.3s ease-in-out'
        }}
      />
      <p>{isProcessing ? `Carregando... ${Math.round(progress)}%` : ''}</p>
    </div>
  )
})

export default FakeProgress
